import { Row } from "antd";
import styled from "styled-components";

export const ContentSection = styled.section`
  position: relative;
  padding: 10rem 0 8rem;
  width: 100%;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media only screen and (max-width: 1024px) {
    padding: 4rem 0 4rem;
  }
`;


export const Content = styled("p")`
  margin: 1.5rem 0 2rem 0;
`;

export const StyledRow = styled(Row)`
  flex-direction: ${({ direction }: { direction: string }) =>
        direction === "left" ? "row" : "row-reverse"};
`;

export const StyledBanner = styled("div")`
  color: '#2159A6',
  @media only screen and (max-width: 575px) {
    padding-top: 4rem;
  }
`;

export const ContentWrapper = styled("div")`
  position: relative;
  max-width: 540px;
  padding-left: 50px;

  @media only screen and (max-width: 575px) {
    padding-top: 4rem;
  }
`;

export const ServiceWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
`;

export const CoreTitle = styled("h6")`
  font-size: 90px;
  line-height: 1rem; 
  padding: 4rem 0 0;
  color: #2159A6;
  font-family: "Gilroy Bold", sans-serif;

  @media only screen and (max-width: 768px) {
    font-size: 60px;
    padding: 3rem 1rem 0;
  }

  @media only screen and (max-width: 480px) {
    font-size: 48px;
    padding: 4rem 1rem 0;
  }
`;


export const MinKeywords = styled("p")`
  font-size: 50px;
  line-height: 1rem;
  color: #2A3273;
  font-family: "Gilroy Bold", sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 16px;

  @media only screen and (max-width: 900px) {
    font-size: 40px;
    padding: 10px 1rem;
  }

  @media only screen and (max-width: 768px) {
    font-size: 28px;
    padding: 10px 1rem;
  }

  @media only screen and (max-width: 480px) {
    font-size: 20px;
  }
`;


export const MinPara = styled("p")`
  font-size: 20px;
  line-height: 1.8rem; /* unchanged */
  padding: 2rem 1rem 0;
  color: #000000;
  font-family: "Gilroy Light", sans-serif;

  @media only screen and (max-width: 768px) {
    font-size: 16px;
    padding: 1.5rem 1rem 0;
  }

  @media only screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const ButtonWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;

  @media screen and (min-width: 1024px) {
    max-width: 80%;
  }

  button:last-child {
    margin-left: 20px;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
  }
`;
export const BubbleCard = styled(StyledRow)`
  background-color: #fff;
  min-height: 250px;
  max-width: 1050px;
  padding: 20px 0;
  border-radius: 40px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  margin-top: -75px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;

  @media screen and (max-width: 1024px) {
    max-width: 760px;
  }

  @media screen and (max-width: 768px) {
    max-width: 640px;
  }

  @media screen and (max-width: 480px) {
    max-width: 320px;
  }

  @media screen and (max-width: 344px) {
    max-width: 290px;
  }

`;
